const base_Url="https://wtsacademy.dedicateddevelopers.us/"
export const end_points={
    signup:"api/user/signup",
    signin:"api/user/signin",
    profile:"api/user/profile-details"
}

export default base_Url